/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChangePwAliases {
  BUTTON_ALT_PW = 'button-alt-pw',
  BUTTON_OK = 'button-ok',
  FIELD_CURRENT_PW = 'field-current-pw',
  FIELD_NEW_PW = 'field-new-pw',
  FIELD_NEW_PW_CONFIRM = 'field-new-pw-confirm',
  FORM_ALT_PW = 'form-alt-pw',
  IMAGE_0 = 'image-0',
  INPUT_CURRENT_PW = 'input-current-pw',
  INPUT_NEW_PW = 'input-new-pw',
  INPUT_NEW_PW_CONFIRM = 'input-new-pw-confirm',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  MODAL_PWS = 'modal-pws',
  MODAL_SUCCESS = 'modal-success',
  PANEL_2 = 'panel-2',
  PANEL_4 = 'panel-4',
  PANEL_BTN = 'panel-btn',
  PANEL_FORM = 'panel-form',
  PANEL_MODAL = 'panel-modal',
  PANEL_SUCCESS = 'panel-success',
  TEXT_2 = 'text-2',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { ChangePwAliases };
